import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia previa?',
  answer: 'No. Está pensado para empezar desde cero.'
}, {
  question: '¿Funciona en cualquier ciudad?',
  answer: 'Sí. Podés vender desde tu casa usando redes o WhatsApp.'
}, {
  question: '¿Cuándo recibo el contenido?',
  answer: 'El acceso es inmediato después del pago, llegará a tu mail.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tenés 7 días de garantía. Si no te convence, te devolvemos el dinero.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-charcoal-dark relative" data-id="element-80">
      <div className="max-w-2xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-82">
          <h2 className="text-3xl sm:text-4xl font-bold" data-id="element-83">
            Preguntas{' '}
            <span className="text-gold italic font-normal" data-id="element-84">
              antes de empezar
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-85">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-charcoal border border-white/10 rounded-xl overflow-hidden" data-id="element-86">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-87">
                <span className="text-base font-medium text-cream pr-4" data-id="element-88">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-89" />
              </button>
              <AnimatePresence data-id="element-90">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-91">
                    <div className="px-5 pb-5 text-cream-muted/80" data-id="element-92">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}